module.exports = __webpack_public_path__ + "img/only-man.19876fd9.svg";